import type { NavigateOptions } from 'react-router-dom';
import { useCallback } from 'react';
import { useNavigate as useReactRouterDomNavigate } from 'react-router-dom';

import type { IAppRegion } from '~/lib/appSettings';
import { useOptionalAppRegion } from '~/hooks/useOptionalAppRegion';
import { getNavigationUrl } from './getNavigationUrl';

export type INavigateOptions = NavigateOptions & { appRegion?: IAppRegion };

export type INavigateFunction = (
  to: string,
  options?: INavigateOptions,
) => void;

export const useNavigate = (): INavigateFunction => {
  const navigate = useReactRouterDomNavigate();
  const appRegion = useOptionalAppRegion();

  const navigateWithRegion = useCallback(
    (to: string, options?: INavigateOptions): void => {
      const url = getNavigationUrl(to, appRegion ?? options?.appRegion);
      navigate(url, options);
    },
    [navigate, appRegion],
  );

  return navigateWithRegion;
};
